import {
  Button,
  type DialogProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Flex,
  Text,
} from '@shared/components';

import {
  ImportWrIncompleteList,
  type ImportWrIncompleteListProps,
} from '../import-wr-incomplete-list';
import { ImportWrSummaryCard, type ImportWrSummaryCardProps } from '../import-wr-summary-card';

export interface ImportExamineesFromWrResultModalProps
  extends Pick<DialogProps, 'slotProps' | 'maxWidth'> {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  summary?: ImportWrSummaryCardProps;
  errors?: ImportWrIncompleteListProps['errors'];
}

export default function ImportExamineesFromWrResultModal(
  props: Readonly<ImportExamineesFromWrResultModalProps>,
) {
  const { open: isOpen, title, description, onClose, summary, errors, slotProps, maxWidth } = props;
  const hasErrors = Boolean(errors?.length);

  return (
    <Dialog open={isOpen} maxWidth={maxWidth} onClose={onClose} slotProps={slotProps}>
      {hasErrors ? (
        <>
          <DialogTitle onClose={onClose}>{title}</DialogTitle>
          <Divider />
        </>
      ) : (
        <DialogTitle>{title}</DialogTitle>
      )}
      <DialogContent>
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
          {description ? <Text variant='body1'>{description}</Text> : null}
          {summary ? (
            <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
              <Text variant='body1Semibold'>สรุปสถานะผู้เข้าสอบในรอบสอบนี้</Text>
              <ImportWrSummaryCard {...summary} />
            </Flex>
          ) : null}
          {hasErrors ? <ImportWrIncompleteList errors={errors ?? []} /> : null}
        </Flex>
      </DialogContent>
      {hasErrors ? <Divider /> : null}
      <DialogActions>
        <Button onClick={onClose}>ปิด</Button>
      </DialogActions>
    </Dialog>
  );
}
